import {
  getSpaceEvaluatingList,
  saveInviteStatus,
  getSpaceList,
  getSpaceDemandDetail,
  saveDemand,
  sendDesigner,
  getCustomerInfo,
  getOtherSpaces
} from '@/api/radTwo'

const state = {
}

const mutations = {
}

const actions = {
  // d-05-(rad2)空间需求评估列表
  getSpaceEvaluatingList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getSpaceEvaluatingList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // (rad2)-01-用户接受邀请
  saveInviteStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveInviteStatus(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // (rad2)-02-空间列表
  getSpaceList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getSpaceList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // (rad2)-03-获取空间需求列表
  getSpaceDemandDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getSpaceDemandDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // (rad2)-04-空间需求提交
  saveDemand({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveDemand(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // (rad2)-05-预勘测信息发送设计师
  sendDesigner({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      sendDesigner(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // (rad2)-06-用户基本信息
  getCustomerInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getCustomerInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // designer-01-设计服务空间列表
  getOtherSpaces({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOtherSpaces(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
